import { render, staticRenderFns } from "./InputDate.global.vue?vue&type=template&id=6f27f01b&scoped=true&lang=pug&"
import script from "./InputDate.global.vue?vue&type=script&lang=ts&"
export * from "./InputDate.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputDate.global.vue?vue&type=style&index=0&id=6f27f01b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27f01b",
  null
  
)

export default component.exports